const Footer = () => {
  return <footer>&copy; Asanda Majola 2022</footer>;
};

export default Footer;
